module.exports = __webpack_public_path__ + "static/media/fence_builder.33561389.svg";